import React from 'react';
import { Helmet } from 'react-helmet';

// Suppress the UNSAFE_componentWillMount warning for react-helmet
const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('UNSAFE_componentWillMount')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const HelmetWrapper = (props) => {
  return <Helmet {...props} />;
};

export default HelmetWrapper;
